import { render } from "./InputPwRecovery.vue?vue&type=template&id=59bfd864&scoped=true"
import script from "./InputPwRecovery.vue?vue&type=script&lang=js"
export * from "./InputPwRecovery.vue?vue&type=script&lang=js"

import "./InputPwRecovery.vue?vue&type=style&index=0&id=59bfd864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59bfd864"]])

export default __exports__